import _objectSpread from "/Users/fangyu/Code/unifygama/metacrm/metadesk-frontend/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
/* eslint-disable import/no-dynamic-require */
import React, { useState, useMemo, useRef } from 'react';
import { Box } from '@mui/material';
export const SIZE = {
  XL: 'extraLarge',
  LARGE: 'large',
  MEDIUM: 'medium',
  SMALL: 'small',
  XS: 'extraSmall',
  XSS: 'extraSmallSmall'
};
export const COLOR = {
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
  ERROR: 'error',
  WARNING: 'warning',
  INFO: 'info',
  SUCCESS: 'success',
  DEFAULT: 'default',
  SETTING: 'setting'
};
export const VARIANT = {
  CONTAINED: 'contained',
  OUTLINED: 'outlined',
  TEXT: 'text',
  DEFAULT: 'default',
  SHADOW: 'shadow'
};
export const SpinnerVariant = {
  DETERMINATE: 'determinate',
  INDETERMINATE: 'indeterminate'
};
export const TYPE_IN_HTML = {
  TEXT: 'text',
  NUMBER: 'number',
  TEL: 'tel',
  EMAIL: 'email'
};
export const TYPE = _objectSpread({
  DEFAULT: 'default',
  SEARCH: 'search',
  PASSWORD: 'password'
}, TYPE_IN_HTML);
export const TAG_COLORS = ['#C2F0B6', '#D6BBFB', '#FDA19B', '#FEC84B', '#6CE9A6', '#7CD4FD', '#A4BCFD', '#BDB4FE', '#FAA7E0', '#EBD9B7', '#D0D5DD', '#EABBFB', '#FDBE9B', '#FEAC4B', '#6CE9E2', '#7CB0FD', '#BBFDA4', '#E0FF89', '#FCCEEE', '#F3E87F'];